import { Pipe, PipeTransform } from '@angular/core';
import { ResponseTemplate } from '../common-review-card/review-types';

@Pipe({
  name: 'randomizeTemplates',
  standalone: false,
})
export class RandomizeTemplatesPipe implements PipeTransform {
  static randomizeTemplates(responseTemplates: ResponseTemplate[]): ResponseTemplate[] {
    let curIndex = responseTemplates.length;
    while (curIndex > 0) {
      curIndex -= 1;
      const randIndex = Math.floor(Math.random() * curIndex);
      const tempValue = responseTemplates[curIndex];
      responseTemplates[curIndex] = responseTemplates[randIndex];
      responseTemplates[randIndex] = tempValue;
    }
    return responseTemplates;
  }

  transform(responseTemplates: ResponseTemplate[]): ResponseTemplate[] {
    if (!responseTemplates) {
      return [];
    }
    return RandomizeTemplatesPipe.randomizeTemplates(responseTemplates);
  }
}
